import React, { useEffect } from "react";
import { Typography, Box, createStyles } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Clear";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = (theme) =>
  createStyles({
    paper: {
      position: "absolute",
      width: 300,
      height: "85vh",
      boxShadow: theme?.shadows?.[5] || "0px 4px 6px rgba(0, 0, 0, 0.1)",
      padding: theme?.spacing ? theme.spacing(2, 1, 2, 2) : "16px 8px",
      color: "#fff",
      backgroundImage: "linear-gradient(to top,#90bce7 0%, #4397E6 100%)",
    },
    scrollableContent: {
      overflow: "scroll",
      height: "80%",
    },
    header: {
      fontSize: 24,
      fontWeight: "bold",
      margin: "20px 0",
    },
    closeIcon: {
      color: "#fff",
    },
  });

const DisclaimerModal = ({ classes, open, handleClose, lection }) => {
  const [modalStyle] = React.useState(getModalStyle);

  const makeScrollable = () => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;

    document.querySelector(".scrollable").addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  };

  useEffect(() => {
    setTimeout(makeScrollable, 1000);
  });

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={open}
      onClose={handleClose}
    >
      <div style={modalStyle} className={classes.paper}>
        <Box
          display="flex"
          justifyContent="flex-end"
          width="100%"
          className={classes.closeIcon}
        >
          <CloseIcon onClick={handleClose} />
        </Box>
        <Typography
          align="left"
          variant="h2"
          component="p"
          className={classes.header}
          color="inherit"
        >
          {!lection.legalText && "Pflichttext"}
        </Typography>
        <Box className={`scrollable ${classes.scrollableContent}`}>
          <Typography
            align="left"
            variant="body2"
            component="p"
            color="inherit"
          >
            <Box
              dangerouslySetInnerHTML={{
                __html: lection.legalText || lection.course.legalText,
              }}
            />
          </Typography>
        </Box>
      </div>
    </Modal>
  );
};

export default withStyles(styles)(DisclaimerModal);
